import script from "./CustomerOrdersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerOrdersTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BottlesList from "@/components/BottlesList.vue";
import NeuePagination from "@/components/neue/NeuePagination.vue";
script.components = Object.assign({}, { BottlesList, NeuePagination }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BottlesList, NeuePagination }, script.__o.components);}